import {useDispatch, useSelector} from "react-redux";
import React, {useCallback, useEffect, useState} from "react";
import {
    ContentDetailInfoShell,
    ContentDetailThreeColLayout,
    DetailFormTabChrome,
    DetailKvTable,
    DetailPanel,
    DetailSummaryButton,
} from "../../../components/detailLayout";
import Th_title from "../../../components/Th_title";
import {SelectComboBoxForCreate} from "../../../components/select/SelectComboBoxForCreate";
import ApprovalComponent from "../../settings/approval/new/ApprovalComponent";
import {inspectionRequestCode, useSla} from "./InspectionCreate";
import {getFlatCode, maintenanceVaild} from "../../../components/commonmethod/CommonMethod";
import ReadOnlyInputBasic from "../../../components/input/ReadOnlyInputBasic";
import {getInspection, updateInspection} from "../../../api/maintenance/InspectionService";
import {
    changeProgressStatusValue,
    changeStatusNumericValue,
} from "../../../redux/slice/contentSlice";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {getMaintenanceAssetsFromDetail, getMaintenanceHandlersFromDetail} from "../shared/maintenanceHandlerUtils";
import {CacheType, CodeSpecNum, ContentCategory} from "../../../constant/CodeSpecNum";
import {getContentStatus} from "../../../api/contentStatus/contentStatusService";
import {apiLoading, skeleton} from "../../../redux/slice/apiSlice";
import {onCreateClickListener} from "../../../components/commonmethod/simmsDrawerMethod";
import SimmsInputSearch from "../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../components/drawer/simms/SimmsDrawerSearch";
import UserSelectionField from "../../../components/selection/UserSelectionField";
import SearchSelector from "../../../components/searchSelector/SearchSelector";
import {inputOnChange} from "../../../components/commonmethod/simmsInputMethod";
import SimmsInput from "../../../components/input/SimmsInput";
import Selector from "../../../components/selector/Selector";
import SimmsDatePicker from "../../../components/datepicker/SimmsDatePicker";
import {dateOnChange} from "../../../components/commonmethod/simmsDateMethod";
import dayjs from "dayjs";
import SimmsTextArea from "../../../components/input/SimmsTextArea";
import {SimmsRadio} from "../../../components/input/SimmsRadio";
import {selectCodesByParentId} from "../../../api/code/CodeService";
import {useCacheRefresh} from "../../../hooks/useCacheRefresh";
import {
    clearApprovalProcessState,
    getApprovalProcessSubmitPayload,
    preloadApprovalProcessFromFlatCode,
} from "../../settings/approval/shared/approvalProcessStore";

function InspectionUpdate() {
    const { id } = useParams();
    const dispatch = useDispatch();

    const location = useLocation();
    const navigate = useNavigate();

    const [docs, setDocs] = useState([]);
    const refreshCache = useCacheRefresh();

    const [inspection, setInspection] = useState({});
    const [assets, setAssets] = useState([]);
    const [handler, setHandler] = useState([]);
    const [flatInspectionCode, setFlatInspectionCode] = useState([]);
    const approvalProcessId = useSelector((state) => state.content.approvalProcess?.id);
    const approvalProcessIdAfter = useSelector((state) => state.content.approvalProcessAfter?.id);

    const preloadApprovalProcesses = useCallback((codeId, flatList) => {
        preloadApprovalProcessFromFlatCode(dispatch, codeId, flatList);
    }, [dispatch]);

    useEffect(() => {
        clearApprovalProcessState(dispatch);
        return () => clearApprovalProcessState(dispatch);
    }, [dispatch, id]);

    useEffect(() =>{
        Promise.all([
            getInspection(id),
            getContentStatus({contentId : id, contentCategory : ContentCategory.INSPECTION})
        ]).then(([inspectionResponse, statusNumericValueResponse]) => {
            setInspection(inspectionResponse.data);
            setInspection((prev) =>({
                ...prev,
                assetSingleOrBulkUse : "bulk",
                periodDateLimit : 1,
                required_validate : {
                    periodDateLimit : true
                }
            }))

            if (statusNumericValueResponse && statusNumericValueResponse.status === 200) {
                const numericValue = statusNumericValueResponse.data.statusNumericValue;
                dispatch(changeStatusNumericValue(numericValue));
                dispatch(changeProgressStatusValue(statusNumericValueResponse.data));
            }

            return selectCodesByParentId(CodeSpecNum.InspectionRequestCode)
                .then(inspectionCodeResponse => {
                    setFlatInspectionCode(getFlatCode(inspectionCodeResponse));
                })
                .then(() => {
                    setAssets(getMaintenanceAssetsFromDetail(inspectionResponse.data));
                    setHandler(getMaintenanceHandlersFromDetail(inspectionResponse.data));
                })
        }).finally(
            dispatch(skeleton(false))
        )
    }, [id, dispatch])

    const requireds =["title", "requester", "inspectCode", "inspectStartDate", "inspectEndDate", "useSla", "inspector"]
    const update = async () => {
        if(assets.length == 0){
            alert("자산을 선택해주세요")
            return false;
        }

        if (!maintenanceVaild(handler, inspection, requireds)) return;

        dispatch(apiLoading(true));

        const docFile = []
        docs.forEach(each => docFile.push(each.object))

        const data = {
            ...inspection,
            ...getApprovalProcessSubmitPayload({includeAfter: true}),
            inspectCode : {id : inspection.inspectCode.id},
            inspector : {id : inspection.inspector.id},
            requester : {id : inspection.requester.id}
        }

        await updateInspection(data, assets, handler, docFile).then(response => {
            if(response.status === 200){
                alert("점검이 접수되었습니다.")
                refreshCache(CacheType.INSPECTION);
                navigate("/maintenance/inspection/"+id, {
                    state: {
                        test: location.state
                    }
                });
            }
        }).finally(dispatch(apiLoading(false)));
    }

    useEffect(() => {
        if (!inspection.inspectCode?.id || flatInspectionCode.length === 0) {
            return;
        }
        preloadApprovalProcesses(inspection.inspectCode.id, flatInspectionCode);
    }, [inspection.inspectCode?.id, flatInspectionCode, preloadApprovalProcesses]);

    const summaryMeta = [
        inspection.inspectCode?.name && `코드 ${inspection.inspectCode.name}`,
        inspection.requester?.name && `요청 ${inspection.requester.name}`,
    ].filter(Boolean).join(" · ");

    const goToDetail = () => navigate(`/maintenance/inspection/${id}`);

    const requestInfoPanel = (
        <DetailPanel title={"점검요청정보"}>
            <DetailKvTable>
                <tbody>
                    <tr className="asset-detail-kv-row--auto">
                        <Th_title title={"자산목록"} colspan={3} className="fieldset-td relative align-top" required auth={inspection.auth?.update}>
                            <UserSelectionField
                                layout="inline"
                                data={assets}
                                countUnit="개"
                                chipEntity="asset"
                                onRemove={(v) => setAssets((prev) => prev.filter((asset) => asset.id !== v.id))}
                            >
                                <SearchSelector
                                    auth={inspection.auth?.update}
                                    multiSelect
                                    variant="compact"
                                    entity="maintenance-assets"
                                    uniqueKey="assets"
                                    data={assets}
                                    onChange={(v) => {
                                        if (v?.__multiFlat) setAssets(v.__multiFlat);
                                    }}
                                >
                                    <SimmsInputSearch type="TEXT" />
                                    <SimmsDrawerSearch showLabel title="자산그룹" entity="code" target="group" parentKey={CodeSpecNum.AssetGroupCode} uniqueKey="group" recursive />
                                    <SimmsDrawerSearch showLabel title="업무그룹" entity="code" target="task" parentKey={CodeSpecNum.TaskGroupCode} uniqueKey="task" recursive />
                                    <SimmsDrawerSearch showLabel title="자산위치" entity="code" target="location" parentKey={CodeSpecNum.AssetLocation} uniqueKey="location" recursive />
                                    <SimmsDrawerSearch showLabel title="SLA 그룹" entity="code" target="slaGroup" parentKey={CodeSpecNum.SlaGroupCode} uniqueKey="slaGroup" recursive />
                                    <SimmsDrawerSearch showLabel title="운영담당자" entity="userAccount" target="operator" />
                                    <SimmsDrawerSearch showLabel title="자산사용자" entity="userAccount" target="handler" />
                                </SearchSelector>
                            </UserSelectionField>
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"등록일시"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"createdAt"} data={{data: inspection, setData: setInspection}} value={inspection.createdAt} />
                        </Th_title>
                        <Th_title title={"등록자"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"createdBy"} data={{data: inspection, setData: setInspection}} value={inspection.createdBy} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"수정일시"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"updatedAt"} data={{data: inspection, setData: setInspection}} value={inspection.updatedAt} />
                        </Th_title>
                        <Th_title title={"수정자"} colspan={1} className="fieldset-td">
                            <ReadOnlyInputBasic target={"updatedBy"} data={{data: inspection, setData: setInspection}} value={inspection.updatedBy} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"점검 제목"} colspan={3} className="fieldset-td" required auth={inspection.auth?.update}>
                            <SimmsInput onChange={(v)=>inputOnChange(setInspection,"title", v, true)} data={inspection.title} />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"요청자"} colspan={3} className="fieldset-td" required auth={inspection.auth?.update}>
                            <Selector
                                onChange={(v)=>onCreateClickListener(setInspection, "requester", inspection.requester ,v)}
                                data={inspection.requester}
                                entity={"userAccount"}
                                uniqueKey={'requester'}
                            >
                                <SimmsInputSearch type={'TEXT'} placeHolder={"사용자명"} />
                                <SimmsDrawerSearch showLabel title={'부서'} entity={'department'} target={'department'} recursive />
                                <SimmsDrawerSearch showLabel title={'업체'} entity={'company'} target={'company'} />
                            </Selector>
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"점검코드"} colspan={1} className="fieldset-td" required auth={inspection.auth?.update}>
                            <Selector
                                onChange={(v)=>onCreateClickListener(setInspection, "inspectCode", inspection.inspectCode ,v)}
                                data={inspection.inspectCode}
                                entity={"code"}
                                parentKey={CodeSpecNum.InspectionRequestCode}
                                recursive
                            />
                        </Th_title>
                        <Th_title title={"요청방식"} colspan={1} className="fieldset-td" auth={inspection.auth?.update}>
                            <SelectComboBoxForCreate target={"requestCode"} options={inspectionRequestCode}
                                                     data={{data: inspection, fnc: setInspection}}
                                                     defaultValue={inspection.requestCode == 0 ? "" : inspection.requestCode}/>
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"점검기간"} colspan={3} className="fieldset-td fieldset-td-input" required>
                            <div className="web-flex asset-detail-date-range">
                                <SimmsDatePicker
                                    onChange={(v)=>dateOnChange(setInspection,"inspectStartDate", v, true)}
                                    data={inspection.inspectStartDate}
                                    constraint={{lessThan : inspection.inspectEndDate && dayjs(inspection.inspectEndDate)}} auth={inspection.auth?.update} />
                                <span className="asset-detail-date-range-sep">~</span>
                                <SimmsDatePicker
                                    onChange={(v)=>dateOnChange(setInspection,"inspectEndDate", v, true)}
                                    data={inspection.inspectEndDate}
                                    constraint={{largerThan : inspection.inspectStartDate && dayjs(inspection.inspectStartDate)}} auth={inspection.auth?.update} />
                            </div>
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"SLA 사용여부"} colspan={3} className="fieldset-td" required auth={inspection.auth?.update}>
                            <SimmsRadio
                                options={useSla}
                                onChange={(v) => inputOnChange(setInspection,"useSla", v, true)}
                                data={inspection.useSla}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"비고"} colspan={3} className="fieldset-td" auth={inspection.auth?.update}>
                            <SimmsTextArea onChange={(v)=>inputOnChange(setInspection,"etc", v, false)} data={inspection.etc} style={{minHeight:"80px"}} />
                        </Th_title>
                    </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    const workflowPanels = (
        <>
            <DetailPanel title={"점검 요청 진행상태"}>
                <DetailKvTable>
                    <tbody>
                        <tr className="asset-detail-kv-row--auto">
                            <Th_title title={"담당자"} colspan={3} className="fieldset-td fieldset-td-input relative align-top" required auth={inspection.auth?.update}>
                                <UserSelectionField
                                    layout="inline"
                                    data={handler}
                                    onRemove={(v) => setHandler((prev) => prev.filter((h) => h.id !== v.id))}
                                >
                                    <SearchSelector
                                        auth={inspection.auth?.update}
                                        multiSelect
                                        variant="compact"
                                        entity="userAccount"
                                        uniqueKey="handler"
                                        data={handler}
                                        onChange={(v) => {
                                            if (v?.__multiFlat) setHandler(v.__multiFlat);
                                        }}
                                    >
                                        <SimmsInputSearch type="TEXT" placeHolder="사용자명" />
                                        <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive />
                                        <SimmsDrawerSearch showLabel title="업체" entity="company" target="company" />
                                    </SearchSelector>
                                </UserSelectionField>
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"검수자"} colspan={3} className="fieldset-td" required auth={inspection.auth?.update}>
                                <Selector
                                    onChange={(v)=>onCreateClickListener(setInspection, "inspector", inspection.inspector ,v)}
                                    data={inspection.inspector}
                                    entity={"userAccount"}
                                    uniqueKey={'inspector'}
                                >
                                    <SimmsInputSearch type={'TEXT'} placeHolder={"사용자명"} />
                                    <SimmsDrawerSearch showLabel title={'부서'} entity={'department'} target={'department'} recursive />
                                    <SimmsDrawerSearch showLabel title={'업체'} entity={'company'} target={'company'} />
                                </Selector>
                            </Th_title>
                        </tr>
                    </tbody>
                </DetailKvTable>
            </DetailPanel>
        </>
    );

    const asidePanel = (
        <>
            <ApprovalComponent auth={inspection.auth?.update} approvalProcessId={approvalProcessId} />
            <ApprovalComponent
                auth={inspection.auth?.update}
                title={"사후결재"}
                approvalSeparator={true}
                approvalProcessId={approvalProcessIdAfter}
            />
        </>
    );

    if(Object.keys(inspection).length > 0 && Object.keys(flatInspectionCode).length > 0) {
        return (
            <div className="common-container container-height detail-list-layout asset-detail-list-layout border-l-gray flex min-h-0 flex-1 flex-col">
                <DetailFormTabChrome>
                <ContentDetailInfoShell
                    title={inspection.title || "점검 접수"}
                    meta={summaryMeta || undefined}
                    contentId={id}
                    contentCategory={ContentCategory.INSPECTION}
                    scrollMode="columns"
                    actions={
                        <DetailSummaryButton muted onClick={goToDetail}>
                            취소
                        </DetailSummaryButton>
                    }
                    rollup={{
                        update: inspection.auth?.update ? update : "",
                        updateTitle: "접수완료",
                    }}
                >
                    <ContentDetailThreeColLayout
                        primary={requestInfoPanel}
                        secondary={workflowPanels}
                        aside={asidePanel}
                    />
                </ContentDetailInfoShell>
                </DetailFormTabChrome>
            </div>
        )
    }
}

export {InspectionUpdate}
